export const zoomProp = {
  animationDuration: 500,
  minZoomPixelRatio: 1,
  maxZoomPixelRatio: 2,
  zoomInMultiplier: 2,
  doubleTapDelay: 300,
  doubleClickDelay: 300,
  doubleClickMaxStops: 2,
  keyboardMoveDistance: 50,
  wheelZoomDistanceFactor: 1000,
  pinchZoomDistanceFactor: 1.2,
  scrollToZoom: true
}
